<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting" epub:type="chapter" id="vol-1-chapter-10" role="doc-chapter">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">10</h1>
</div>
</div>
</div>
</div>
<div class="text" id="vol-1-chapter-10-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-w"><span class="drop-cap">W</span>hen Black entered the waiting room, he saw that the only people occupying it were Jennifer and Merryn. It was a depressing place, the furniture comprising a row of blue plastic chairs along one wall and a low squat table with scattered out-of-date <i>Interior Design</i> magazines. A coffee machine was in a corner with a sign stating it was out of order. The lighting was the same strip lighting in the interview room. Bright, glaring. There were no windows, and the place was cold. <i>Rooms with no windows,</i> thought Black – <i>the architect should be shot.</i></p>
<p class="subsq">Merryn was in a pink and orange onesie, and lying across two seats under a blanket, asleep.</p>
<p class="subsq">Jennifer rose to her feet.</p>
<p class="subsq">“My God, Adam. What the hell’s going on? I got a call from Simon…”</p>
<p class="subsq">Black held her close, smelled the clean soap on her skin, the fragrance of her hair. She didn’t belong in a place like this.</p>
<p class="subsq">“I’ll tell you back at the house,” he whispered in her ear. “Over a drink.”</p>
<p class="subsq">Jennifer held him tighter. “What happened, Adam?”</p>
<p class="subsq">“Shit happened. Unbelievable shit. But it’s okay. It’s all okay.” He held her back a little and attempted a smile. “I guess it’s soggy pasta.”</p>
<p class="subsq">She began to sob, and he held her again, thinking of the blood moon and her prediction of bad luck, and let the moment drift.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001chapter010.vue?4d50b853